import subscribeForm from '@modules/subscribe-form';
import mobileNavigation from '@modules/mobile-menu';
import mobileSearch from '@modules/mobile-search';
import stickyHeader from '@modules/sticky-header';
import bxSlideshow from '@modules/bx-slideshow';
import youtubeVideo from '@modules/embed-youtube';
import frontpageCarousel from '@modules/ad-carousel';
import FooterSubscribeForm from '@modules/FooterSubscribeForm';
import sidebarHide from '@modules/sidebar-hide';
import RelatedProducts from '@modules/related-products';
import RandomBanner from '@modules/random-banner';
import InviteBanner from '@modules/invite-banner';
import PseudoLink from '@modules/pseudo-link';
import SubscribeDialog from '@modules/subscribe-dialog';
import flexibleSidebar from '@modules/flexible-sidebar';

import './scripts/copy-handler';
import lazyload from './functions/lazyload';

lazyload();
// import './scripts/clamp-widgets';

/**
 * List all compontents that are initialised
 * using the data-behavior attr within this object
 * @type {Object}
 */
const importedComponents = {
    FooterSubscribeForm,
    mobileSearch,
    flexibleSidebar,
    stickyHeader,
    bxSlideshow,
    youtubeVideo,
    subscribeForm,
    mobileNavigation,
    frontpageCarousel,
    sidebarHide,
    RelatedProducts,
    InviteBanner,
    RandomBanner,
    PseudoLink,
    SubscribeDialog,
};

const COMPONENT_IDENTIFIER = 'data-component';

/**
 * [initComponents description]
 * @param  {HTMLElement} [rootNode=document.body] The element from which to start
 * @return {boolean}                         default value
 */
function initComponents(rootNode = document.body) {
    // Fetch components from root node
    const components = rootNode.querySelectorAll(`[${COMPONENT_IDENTIFIER}]`);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < components.length; i++) {
        const componentNode = components[i];
        const componentName = componentNode.getAttribute(COMPONENT_IDENTIFIER).split(' ');

        componentName.forEach(currentName => {
            // Has the component been initalised already?
            if (!componentNode[`_initalisedComponent_${currentName}`]) {
                // Check we have the module loaded in this bundle or else throw a warning
                // eslint-disable-next-line no-prototype-builtins
                if (importedComponents.hasOwnProperty(currentName)) {
                    const Component = importedComponents[currentName];
                    componentNode[`_initalisedComponent_${currentName}`] = new Component(
                        componentNode,
                        currentName
                    );
                    console.log(`${currentName} loaded`);
                } else {
                    // eslint-disable-next-line no-unused-expressions
                    window.console && console.warn(`${currentName} has not been imported into this bundle`);
                }
            }
        });
    }
}

/**
 * Removes the preload class which is used to
 * prevent any CSS animations or transitions that occur on load
 * @return {boolean} default value
 */
function initTransitions() {
    // Warning: classList is not supported in IE8
    document.body.classList.remove('preload');
}

initComponents();
initTransitions();
